import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare, faSquareCheck } from '@fortawesome/free-regular-svg-icons';
export const WordSearchForm = ({ wordSearch: wordSearchData, onSubmit, onCancel, }) => {
    const [validationMessage, setValidationMessage] = useState('');
    const [wordSearch, setWordSearch] = useState(wordSearchData || {
        name: '',
        duration: '600',
        settings: {
            randomiseGrid: false,
            sendResultEmail: false,
            public: false,
            timed: false,
        },
    });
    const handleNameChange = (e) => {
        if (e.target.value.length <= 35) {
            setWordSearch({
                ...wordSearch,
                name: e.target.value,
            });
        }
        else {
            e.target.value = e.target.value.slice(0, 35);
        }
    };
    const handleDurationChange = (e) => {
        setWordSearch({
            ...wordSearch,
            duration: e.target.value,
        });
    };
    const handleTimedSettingChange = () => {
        setWordSearch({
            ...wordSearch,
            duration: '600',
            settings: {
                ...wordSearch.settings,
                timed: !wordSearch.settings.timed,
            },
        });
    };
    const handleRandomiseGridSettingChange = () => {
        setWordSearch({
            ...wordSearch,
            settings: {
                ...wordSearch.settings,
                randomiseGrid: !wordSearch.settings.randomiseGrid,
            },
        });
    };
    const handlePublicSettingChange = () => {
        setWordSearch({
            ...wordSearch,
            settings: {
                ...wordSearch.settings,
                public: !wordSearch.settings.public,
            },
        });
    };
    const handleSendResultEmailSettingChange = () => {
        setWordSearch({
            ...wordSearch,
            settings: {
                ...wordSearch.settings,
                sendResultEmail: !wordSearch.settings.sendResultEmail,
            },
        });
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (wordSearch.name === '') {
            setValidationMessage('WordSearch Name cannot be empty');
        }
        else {
            onSubmit(wordSearch);
        }
    };
    return (React.createElement("form", { className: "form", onSubmit: handleSubmit },
        React.createElement("div", { className: "form__control" },
            React.createElement("div", { className: "input-group" },
                React.createElement("input", { type: "text", name: "name", placeholder: "", defaultValue: wordSearch.name, onChange: handleNameChange, onFocus: () => {
                        setValidationMessage('');
                    } }),
                React.createElement("label", null, "Crowssword Name"),
                React.createElement("span", { className: "character-count" },
                    wordSearch.name ? wordSearch.name.length : 0,
                    " / 35")),
            React.createElement("div", { className: "options-group" },
                React.createElement("div", null,
                    React.createElement(FontAwesomeIcon, { id: "A", icon: wordSearch.settings.timed === true ? faSquareCheck : faSquare, className: "faCheckBox", onClick: handleTimedSettingChange }),
                    React.createElement("label", null, "Timed")),
                React.createElement("div", null,
                    React.createElement(FontAwesomeIcon, { id: "A", icon: wordSearch.settings.randomiseGrid === true
                            ? faSquareCheck
                            : faSquare, className: "faCheckBox", onClick: handleRandomiseGridSettingChange }),
                    React.createElement("label", null, "Randomise Grid")),
                React.createElement("div", null,
                    React.createElement(FontAwesomeIcon, { id: "A", icon: wordSearch.settings.sendResultEmail === true
                            ? faSquareCheck
                            : faSquare, className: "faCheckBox", onClick: handleSendResultEmailSettingChange }),
                    React.createElement("label", null, "Send Result Email")),
                React.createElement("div", null,
                    React.createElement(FontAwesomeIcon, { id: "A", icon: wordSearch.settings.public === true ? faSquareCheck : faSquare, className: "faCheckBox", onClick: handlePublicSettingChange }),
                    React.createElement("label", null, "Share Publicly"))),
            wordSearch.settings.timed && (React.createElement("div", { className: "range-group" },
                React.createElement("span", { className: "duration-label" },
                    "Duration:",
                    ' ',
                    wordSearch.duration
                        ? parseInt(wordSearch.duration) < 600
                            ? `0${parseInt(wordSearch.duration) / 60}`
                            : parseInt(wordSearch.duration) / 60
                        : 0,
                    ' ',
                    "min"),
                React.createElement("input", { type: "range", min: '300', max: '3600', step: 300, defaultValue: wordSearch.duration, onChange: handleDurationChange })))),
        React.createElement("div", { className: "form-actions" },
            React.createElement("button", { className: "btn--primary", type: "submit" }, wordSearchData ? 'Update' : 'Create'),
            React.createElement("button", { type: "button", className: "btn--secondary", onClick: onCancel }, "Cancel")),
        React.createElement("p", { className: "validation-message" }, validationMessage)));
};
